import React from 'react';
import { Link } from 'react-router-dom';

const studies = {
	'lb': (
		<Link key="lb" to="/clients/ladbrokes"><div className="tile">
			<div className="image-container">
				<img src="/images/new/logos/case-study/lb-card.png"/>
			</div>
			<div className="details">
				<h5>CASE STUDY: LADBROKES</h5>
				<p>Bet better in-store</p>
			</div>
		</div></Link>
	),

	'sk': (
		<Link key="sk" to="/clients/sodaking"><div className="tile">
			<div className="image-container">
				<img src="/images/new/logos/case-study/sk-card.png"/>
			</div>
			<div className="details">
				<h5>CASE STUDY: SODAKING</h5>
				<p>The KING of soda makers</p>
			</div>
		</div></Link>
	),

	'news': (
		<Link key="news" to="/clients/newscorp"><div className="tile">
			<div className="image-container">
				<img src="/images/new/logos/case-study/news-card.png"/>
			</div>
			<div className="details">
				<h5>CASE STUDY: NEWS CORP</h5>
				<p>#1 for print & digital</p>
			</div>
		</div></Link>
	),

	'bau': (
		<Link key="bau" to="/clients/bitcoin-australia"><div className="tile">
			<div className="image-container">
				<img src="/images/new/logos/case-study/bau-card.png"/>
			</div>
			<div className="details">
				<h5>CASE STUDY: BITCOIN AUSTRALIA</h5>
				<p>The future of finance</p>
			</div>
		</div></Link>
	),
	'goget': (
		<Link key="goget" to="/clients/goget"><div className="tile">
			<div className="image-container">
				<img src="/images/new/logos/case-study/goget-card.png"/>
			</div>
			<div className="details">
				<h5>CASE STUDY: GOGET</h5>
				<p>The leaders in car sharing</p>
			</div>
		</div></Link>
	),
}

export default (props) => {
	return (

		<section className="more">
		    <div className="container">
		    	{props.cases.map(c => studies[c])}
		    </div>
		</section>
	)
}


// WEBPACK FOOTER //
// ./client/components/MoreCaseStudies/index.js